// extracted by mini-css-extract-plugin
module.exports = {"linkClass":"SasriaFNOLSummaryPage_linkClass__3tayi","additionalContactAlignLeft":"SasriaFNOLSummaryPage_additionalContactAlignLeft__3onu5"};